import { ckb } from "../../../../date-fns/locale/ckb.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ckb
  }
};